import {
  HeroAjaxCreatePaxRequest,
  HeroApiBookingProductAddon,
  HeroApiBookingProductPax,
  HeroApiBookingProductRoom,
  HeroApiCreateBookingRequest,
  HeroApiWindcaveSessionRequest,
  Pax,
  PersonBooking,
} from './models';
import { CookieCollection, failedPayment, getUrlParameter, hideLoader, modalalert, removeLastSegmentFromUrl } from './script';
import * as log from 'loglevel';
// @ts-ignore
import moment from 'moment';
import * as Api from './api';
import * as _ from 'lodash';

/**
 * @returns {(PersonBooking|undefined)}
 */
export const processPaymentIsFormValid = () => {
  const isInvalidClassName = 'is-invalid';
  const $title = $('#Title');
  const title = $title.val() as string | undefined; 
  const $firstName = $('#FirstName');
  const firstName = $firstName.val() as string | undefined;
  const $lastName = $('#LastName');
  const lastName = $lastName.val() as string | undefined;
  const $emailAddress = $('#EmailAddress');
  const emailAddress = $emailAddress.val() as string | undefined;
  const $country = $('#Country');
  const country = $country.val() as string | undefined;
  const $postcode = $('#Postcode');
  const postcode = $postcode.val() as string | undefined;
  const $phone = $('#PhoneNumber');
  const phone = $phone.val() as string | undefined;
  const requests = $('#specialRequests').val() as string | undefined;
  const disability = $('#disability').val() as string | undefined;
  const terms = $('#terms').is(':checked');
  const mandatory = $('#mandatory').length == 0 || $('#mandatory').is(':checked') as boolean | undefined;
  const $validationError = $('#ValidationError');
  let error = false;

  // store values in cookie
  const personBooking: PersonBooking = {
    title: title  || '',
    firstName: firstName || '',
    lastName: lastName || '',
    emailAddress: emailAddress || '',
    phoneNumber: phone || '',
    country: country || '',
    postcode: postcode || '',
    specialRequests: requests || '',
    disabilityRequirements: disability || '',
    giftFirstName: '',
    giftLastName: '',
    giftEmailAddress: '',
    giftMessage: '',
    giftValue: 0,
    terms: terms,
    newsletter: $('#newsletter').is(':checked')
  };
  CookieCollection.PersonBooking.set(personBooking);

  log.debug('mandatory: ', mandatory);

  if (!firstName || validator.isEmpty(firstName)) {
    $firstName.addClass(isInvalidClassName);
    error = true;
  } else {
    $firstName.removeClass(isInvalidClassName);
  }

  if (!lastName || validator.isEmpty(lastName)) {
    $lastName.addClass(isInvalidClassName);
    error = true;
  } else {
    $lastName.removeClass(isInvalidClassName);
  }

  if (!postcode || validator.isEmpty(postcode)) 
  {
    $postcode.addClass(isInvalidClassName);
    error = true;   
  } else {
    $postcode.removeClass(isInvalidClassName);
  }

  if (!emailAddress || !validator.isEmail(emailAddress)) {
    $emailAddress.addClass(isInvalidClassName);
    error = true;
  } else {
    $emailAddress.removeClass(isInvalidClassName);
  }

  if (!phone || validator.isEmpty(phone)) {
    $phone.addClass(isInvalidClassName);
    error = true;
  } else {
    $phone.removeClass(isInvalidClassName);
  }

  if (!terms) {
    error = true;
  }

  if (!mandatory) {
    error = true;  
  }

  if (error) {
    $validationError.removeClass('hide');
    return undefined;
  } else {
    $validationError.addClass('hide');
    return personBooking;
  }
};

const getProductQuestionsAndAnswers = () => {
  const answers: string[] = [];

  $('[data-product-question]').each((index, element) => {
    const question = $(element)
      .find('label')
      .text();
    const answer = $(element)
      .find('textarea')
      .val();

    answers.push(`${question}:\n${answer}\n\n`);
  });

  answers.push(`Join Mailing List?:\n${$('#newsletter').is(':checked')}\n\n`);

  return answers;
};

/**
 * @param {(Event | undefined)} e
 */
const processPaymentValidate = (e) => {
  if (e) {
    e.preventDefault();
  }
  const $btn = $('#sendToHero');
  if (!processPaymentIsFormValid()) {
    $btn.attr('disabled', 'disabled');
  } else {
    $btn.removeAttr('disabled');
  }
};

const executeCaptcha = () => {
  grecaptcha.execute();
}

/**
 * @param {MouseEvent} e
 */
const processPaymentOnSendToHeroClick = (e) => {
  e.preventDefault();

  if (!e.target) {
    log.error('e.target should not be null');
    return;
  }

  const $target = $(e.target);
  if ($target.hasClass('disabled')) {
    log.debug('continue button is disabled');
    return;
  }

  const setBooking = async () => {
    log.debug('setBooking');

    const personBooking = processPaymentIsFormValid();
    if (!personBooking) {
      modalalert('Please complete all fields', 'error', false);
      return;
    }

    const addons = CookieCollection.Addons.get() || [];

    const selectedRooms = CookieCollection.SelectedRooms.get();
    if (!selectedRooms) {
      log.error('selectedRooms should not be undefined');
      return;
    }

    const productSearch = CookieCollection.ProductSearch.get();
    if (!productSearch || !productSearch.paxs) {
      log.error('productSearch.paxs should not be undefined');
      return;
    }

    /** @type {Pax[]} */
    const passengers = productSearch.paxs;

    const notes = `Product Questions:\n${getProductQuestionsAndAnswers()}`;

    const bookingProducts: HeroApiBookingProductRoom[] = [];
    for (const selectedRoom of selectedRooms) {
      if (!selectedRoom.checkIn || !selectedRoom.checkOut) {
        log.error('selectedRoom checkin or checkout shall not be false');
        continue;
      }

      const roomNumberRaw = selectedRoom.room;
      if (!roomNumberRaw) {
        log.error('selectedRooms[i].room should not be undefined');
        return;
      }
      const roomNumber: number = _.isString(roomNumberRaw)
        ? parseInt(roomNumberRaw)
        : roomNumberRaw;
      const checkIn = moment(selectedRoom.checkIn);
      const checkout = moment(selectedRoom.checkOut);

      const nights = checkout.diff(checkIn, 'day');
      const room: HeroApiBookingProductRoom = {
        productId: selectedRoom.productId,
        rateCode: selectedRoom.rateCode!,
        productRateCode: selectedRoom.productRateCode!,
        dateCheckIn: selectedRoom.checkIn,
        nights: nights,
        paxRoomId: [],
        voucherNotes: notes,
        paxId: []
      };

      let errorOccurred = false;
      let roomAdultId: string | undefined;

      // for each pax booking cookie
      for (const passenger of passengers) {
        log.debug('passenger.room', passenger.room, 'roomNumber', roomNumber);
        if (passenger.room == roomNumber) {
          // create pax
          const data: HeroAjaxCreatePaxRequest = {
            first: personBooking.firstName,
            last: personBooking.lastName,
            email: personBooking.emailAddress,
            mobile: personBooking.phoneNumber,
            age: passenger.age,
            postcode: personBooking.postcode,
            title: personBooking.title,
            country: personBooking.country
          };

          try {
            const response = await Api.createPax(data);
            const pID = response.data;
            if (!pID) {
              log.error('unable to create pax');
              errorOccurred = true;
              return;
            }

            const hPax: HeroApiBookingProductPax = {
              room: roomNumber,
              paxId: pID.id
            };

            room.paxRoomId.push(hPax);
            if (passenger.age === 18) {
              roomAdultId = pID.id;
            }
          } catch (error) {
            log.error(error);
            errorOccurred = true;
          }
        }
      }

      if (errorOccurred) {
        log.error('error occurred during creation of pax. abort');
        return;
      }

      if (!roomAdultId) {
        log.error('should have at least one adult in booking');
        return;
      }

      bookingProducts.push(room);

      if (addons) {
        if (!roomAdultId) {
          log.error('roomAdult should not be undefined');
        } else {
          for (const addon of addons) {
            if (!addon.productId) {
              log.error('addon.productId should not be undefined');
              continue;
            }
            if (addon.room == roomNumber) {
              const newAddon: HeroApiBookingProductAddon = {
                addonName: addon.addonName,
                paxRoomId: room.paxRoomId,
                productId: addon.productId,
                rateCode: room.rateCode,
                dateCheckIn: addon.productRateCode != null ? addon.productRateCode : room.dateCheckIn,
                productRateCode: room.productRateCode,
                paxId: [],
                price: 0,
                quantity: addon.quantity,
                room: roomNumber,
                questions: []
              };
              newAddon.paxId.push(roomAdultId);
              bookingProducts.push(newAddon);
            }
          }
        }
      }
    }

    const giftVoucher = CookieCollection.GiftVoucher.get()?.code ?? '';
    const discount = CookieCollection.DiscCookie.get()?.per ?? 0;
    const discountCode = CookieCollection.DiscCookie.get()?.code ?? '';
    const siteId = CookieCollection.DiscCookie.get()?.siteId ?? '';
    const stayCodes = CookieCollection.StayVoucher.get()?.codes ?? '';

    const booking: HeroApiCreateBookingRequest = {
      voucherCode: giftVoucher,
      stayNSWvoucherCodes: stayCodes,
      discountPercentage: discount,
      discountCode: discountCode,
      siteId: siteId,
      bookingProducts: bookingProducts
    };

    const createBookingResponse = await Api.createBooking(booking);
    const newBooking = createBookingResponse.data;

    if (newBooking) {
      const validateBookingResponse = await Api.validateBooking(newBooking);
      const validate = validateBookingResponse.data;
      if (validate && validate.IsValid) {
        // newBooking.payable = newBooking.payable;
        CookieCollection.BookingDetails.remove();
        const bookingDetails = {
          id: newBooking.id,
          amount: newBooking.payable
        };
        CookieCollection.BookingDetails.set(bookingDetails);

        if (newBooking.payable > 0) {
          const $captchaToken = $('#Token');
          const captchaToken = $captchaToken.val() as string;
          const sessionRequest = new HeroApiWindcaveSessionRequest(newBooking.id, newBooking.payable.toFixed(2), removeLastSegmentFromUrl(window.location.href), captchaToken);
          const session = await Api.initWindcaveSession(sessionRequest)

          if (session.data.success) {
            // redirect to HPP
            window.location.replace(session.data.sessionRef);
          } else {
            hideLoader();
            failedPayment('', false);
          }
        } else {
          $('#Amount').val(newBooking.payable);

          const tl = $('#Title').val();
          const fn = $('#FirstName').val();
          const ln = $('#LastName').val();
          const em = $('#EmailAddress').val();
          const ph = $('#PhoneNumber').val();

          $('.createbookingwrap').hide();
          
          $('#EPS_AMOUNT').val(newBooking.payable.toFixed(2));
          $('#EPS_REFERENCEID').val(newBooking.id);
          $('.heroid').val(newBooking.id);

          const $p = $('#bookingdetails >  p');
          $p.append('<Br><Br>' + tl + ' ' + fn + ' ' + ln);
          $p.append('<Br>' + em);
          $p.append('<Br>' + ph);
          $('h1').text('CONFIRM & FINALISE');

          $('#paymentNotRequired').show();
          hideLoader();
        }
      } else {
        $('h1').text('There was an error confirming your booking');
        $('.formwrap').remove();
        $('.col-lg-6 p').text(
          'Please call our booking team on 02 9978 4791 and quote booking number ' +
            newBooking.id +
            ' to complete your booking.'
        );
        $('#loader').addClass('hide');
      }
    }
  };

  // show submit button
  $('.form-group-submit').show();

  $('#loader')
    .removeClass('hide')
    .show();

  setTimeout(setBooking, 200);
};

const processPaymentSubmit = () => {
  const $submitButton = $('#submitButton');

  if ($submitButton.attr('disabled')) {
    log.debug('submitting. ignore event');
    return;
  }
  $submitButton.attr('disabled', 'disabled');

  try {
    const bookingDetails = CookieCollection.BookingDetails.get();
   
    if (!bookingDetails) {
      log.error('bookingDetails should not be undefined');
      grecaptcha.reset();
      return;
    }

    // DATA LAYER //
    
    var adults = 0;
    var children = 0;
    var room = 0;
   
    CookieCollection.ProductSearch.get()?.paxs.forEach(paxCount);    
    function paxCount(pax :Pax, index)
    {
       if (pax.age > 17) adults++;
       if (pax.age < 18) children++;
       if (pax.room > room) room = pax.room;
    }

    var rooms = CookieCollection.SelectedRooms.get();
    
    var dataLayer = window.dataLayer = window.dataLayer || [];
    dataLayer.push({
    "event": "bookingComplete", 
    "transactionID": bookingDetails.id,
    "transactionTotal": bookingDetails.amount, 
    "checkIn": CookieCollection.Dates.get()?.checkIn,
    "checkOut": CookieCollection.Dates.get()?.checkOut,
    "page_level_1": $('#siteName').val(),
    "page_level_2": "process-payment",
    "page_level_3": "",
    "page_level_4": "",
    "numberOfAdults": adults,
    "numberOfChildren": children,
    "roomCount": room,
    "transactionProducts": rooms
    });

    // DATA LAYER //

    const amountToBill = $('#EPS_AMOUNT').val() as number;
    if (amountToBill <= 0)
    {
      //attempt to finalise 
      $.ajax({
        url: $("#HERO_BASE").val() + "/api/v2/BookingFinalise/" + $("#EPS_REFERENCEID").val(),
        headers: { 'apiKey': 'a5d3dac3-b70a-476f-8fbb-50ccec419010' },
        context: document.body
      }).done(function() {
        const successUrl = $("#SuccessUrl").val() + "?confirmation_id=" + $("#EPS_REFERENCEID").val();
        window.location.replace(successUrl);
      })
      .fail(function() {
        modalalert('There was an error confirming your booking.', 'error', false);
        $('#sendtoHero').removeAttr('disabled');
      });
    } else{
      hideLoader();
      failedPayment('', false);
      $submitButton.removeAttr('disabled');
      grecaptcha.reset();
    }
  } catch (err) {
    log.error(err);
    $submitButton.removeAttr('disabled');
    modalalert(
      'An error has occurred. Please contact customer support',
      'error',
      false
    );
  }
};

/**
 * Handle submit button for payment form
 */

const handleProcessPaymentEpsFormSubmit = (e: JQuery.Event) => {
   processPaymentSubmit();
};

export function initProcessPayment() {
 
  let html = '<center><h3>Summary</h3></center>';

  const selectedRooms = CookieCollection.SelectedRooms.get();
  if (!selectedRooms || selectedRooms.length == 0) {
    log.error('selectRooms shall not be undefined or with length of 0');
    return;
  }

  const $linkToReviewCart = $('#linkToReviewCart');
  $linkToReviewCart.removeAttr('onclick');
  $linkToReviewCart.on('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const $loader = $('#loader');
    $loader.removeClass('hide');
    $loader.addClass('show');

    const roomLength = selectedRooms.length;
    // noinspection UnnecessaryLocalVariableJS
    const url = `./review-cart?rc=${roomLength}&roommax=${roomLength}`;
    window.location.href = url;
  });

  const personBooking = CookieCollection.PersonBooking.get();
  const addons = CookieCollection.Addons.get() || [];
  log.debug('addons', addons);

  const firstRoom = selectedRooms[0];
  if (!firstRoom.checkIn || !firstRoom.checkOut) {
    log.error('checkin or checkout shall not be undefined');
    return;
  }

  const productSearch = CookieCollection.ProductSearch.get();
  if (!productSearch || !productSearch.paxs) {
    console.error('productSearch should not be undefined');
    return;
  }
  const passengers = productSearch.paxs;

     // DATA LAYER //
    
     var adults = 0;
     var children = 0;
     var room = 0;
    
     CookieCollection.ProductSearch.get()?.paxs.forEach(paxCount);    
     function paxCount(pax :Pax, index)
     {
        if (pax.age > 17) adults++;
        if (pax.age < 18) children++;
        if (pax.room > room) room = pax.room;
     }
 
     var rooms = CookieCollection.SelectedRooms.get();
     
     console.log('pushing roomReview');
     
     var dataLayer = window.dataLayer = window.dataLayer || [];
     dataLayer.push({
     "event": "roomReview", 
     "checkIn": CookieCollection.Dates.get()?.checkIn,
     "checkOut": CookieCollection.Dates.get()?.checkOut,
     "page_level_1": $('#siteName').val(),
     "page_level_2": "process-payment",
     "page_level_3": "",
     "page_level_4": "",
     "numberOfAdults": adults,
     "numberOfChildren": children,
     "roomCount": room,
     "transactionProducts": rooms
     });
 
     // DATA LAYER //



  // populate fields with previously entered values
  if (personBooking) {
    $('#Title').val(personBooking.title || '');
    $('#FirstName').val(personBooking.firstName || '');
    $('#LastName').val(personBooking.lastName || '');
    $('#EmailAddress').val(personBooking.emailAddress || '');
    $('#Postcode').val(personBooking.postcode || '');
    $('#PhoneNumber').val(personBooking.phoneNumber || '');
    $('#specialRequests').val(personBooking.specialRequests || '');
    $('#disability').val(personBooking.disabilityRequirements || '');
    $('#terms').prop('checked', personBooking.terms || false);
    $('#Country').val(personBooking.country || '');





    processPaymentValidate(undefined);
  }

  // validate current data
  // processPaymentValidate(undefined);

  html += `<p class="text-center"><strong>Dates of Stay</strong><br>${moment(
    firstRoom.checkIn
  ).format('DD MMM')} - ${moment(firstRoom.checkOut).format('DD MMM')}</p>`;

  let total = 0;
  let checkBins = false;

  if (productSearch.promoCode != "")
  {
    checkBins = true;
  }

  for (const selectedRoom of selectedRooms) {
    let adultCount = 0;
    let childCount = 0;
    const roomPrice = selectedRoom.price;
    const roomPriceBeforeDiscount = selectedRoom.priceBeforeDiscount;
    const room = selectedRoom.room;
    const roomProductName = selectedRoom.productName;
    if (!room) {
      log.error('selectedRooms[i].room should not be undfined');
      return;
    }
    total += roomPrice;

    // Loop through pax to count room attendees
    for (const passenger of passengers) {
      if (passenger.room == room) {
        if (passenger.age >= 18) {
          adultCount++;
        }
        if (passenger.age < 18) {
          childCount++;
        }
      }
    }

    html += '<div class="bookingrow">';
    html += `<p class="roomtitle"><span class="roomnumber">Room ${
      selectedRoom.room
    }<span class="price">$${roomPrice.toFixed(
      2
    )}</span></span>`;
    if (roomPrice != roomPriceBeforeDiscount)
    {
      html += '<span class="discount"><i class="fa fa-tag"></i> ' + ((1 - roomPrice/roomPriceBeforeDiscount) * 100).toFixed(0) + '% off - you save $' + (roomPriceBeforeDiscount - roomPrice).toFixed(2) + '</span><br />';
      checkBins = true;
    }
    html += `<span class="roomname">${ roomProductName }</span></p>`;
    html += `<p class="paxdetails"><span class="adults">Adults: <em>${adultCount}</em></span>`;
    if (childCount !== 0) {
      html += ` & <span class="children">Children: <em>${childCount}</em></span></p>`;
    }

    const addonsForSelectedRoom = _.filter(
      addons,
      (a: HeroApiBookingProductAddon) => {
        return a.room == selectedRoom.room;
      }
    );
    log.debug('addonsForSelectedRoom.length', addonsForSelectedRoom.length);
    if (addonsForSelectedRoom.length > 0) {
      html += '<div class="addons"><p><strong>Plus:</strong>';

      for (const addon of addonsForSelectedRoom) {
        if (addon.room == selectedRoom.room) {
          html +=
            '<span class="addon">' +
            addon.addonName +
            ' x' +
            addon.quantity +
            ' &nbsp; <span class="addonprice">$' +
            (addon.price * addon.quantity).toFixed(2) +
            '</span></span>';
          total += addon.price * addon.quantity;
        }
      }

      html += '</div>';
    }

    html += '</div>';
  }

  html += '<div class="total">Booking Total: <span>$' + total.toFixed(2) + '</span></div>';
  const voucherValue = CookieCollection.GiftVoucher?.get()?.value;
  if (voucherValue != null && voucherValue > 0)
  {
    html += '<div class="total">Gift Certificate Credit: <span>-$' + voucherValue.toFixed(2) + '</span></div>';

    if (voucherValue > total)
    {      
      html += '<div class="total">Remaining Credit: <span>$' + (voucherValue - total).toFixed(2) + '</span></div>';
    
    }
    else
    {
      html += '<div class="total">Total Due: <span>$' + (total - voucherValue).toFixed(2) + '</span></div>';
    }    
  }

  const stayValue = CookieCollection.StayVoucher?.get()?.value;
  if (stayValue != null && stayValue > 0)
  {
    html += '<div class="total">NSW Stay Credit: <span>-$' + stayValue.toFixed(2) + '</span></div>';

    if (stayValue > total)
    {      
      html += '<div class="total">Remaining Credit: <span>$' + (stayValue - total).toFixed(2) + '</span></div>';
    
    }
    else
    {
      html += '<div class="total">Total Due: <span>$' + (total - stayValue).toFixed(2) + '</span></div>';
    }    
  }

  html += '</div><input type="hidden" name="checkBins" value="';
  if (checkBins) 
  {
    html += 'true">';
  }
  else
  {
    html += 'false">';
  }

  $('#bookingdetails').html(html);

  $('#submitBooking').on('click', processPaymentOnSendToHeroClick);
  $('#sendToHero').on('click', executeCaptcha);

  $('#FirstName').on('change', processPaymentValidate);
  $('#LastName').on('change', processPaymentValidate);
  $('#Postcode').on('change', processPaymentValidate);
  $('#EmailAddress').on('change', processPaymentValidate);
  $('#PhoneNumber').on('change', processPaymentValidate);
  $('#specialRequests').on('change', processPaymentValidate);
  $('#disability').on('change', processPaymentValidate);
  $('#terms').on('change', processPaymentValidate);
  $('#newsletter').on('change', processPaymentValidate);
  
  const questionContainer = $('#additional-questions-container');
  const generateMarkup = (questions: string[]) =>
    [...new Set(questions)]
      .map(
        (question, index) => 
         {
            switch (question.split('|')[1]) 
            {
              case 'text':
                return `<div class="form-group col-12 d-nonee" data-product-question>
                <label data-product-question-label for="question_${index}">${question.split('|')[0]}</label><br/>
                <textarea id="quesiton_${index}" class="form-control optional"></textarea>
                </div>`
              break;
              case 'checkbox':
                return `<div class="form-group col-12 d-nonee form-check" style="margin-left: 15px;">
                    <input class="form-check-input" type="checkbox" id="mandatory" name="mandatory"
                           value="mandatory" />
                    <label class="form-check-label" for="mandatory">
                    ${question.split('|')[0]}                       
                        <span class="req">
                            *
                        </span>
                    </label>
                </div>`
              break;
              default:
                return `<div class="form-group col-12 d-nonee" data-product-question>
                <label data-product-question-label for="question_${index}">${question.split('|')[1]}</label><br/>
                <textarea id="quesiton_${index}" class="form-control optional"></textarea>
                </div>`
              break;
          }
       }
      )
      .join('');

  questionContainer.append(
    generateMarkup(
      _.flatten([
        _.flatten(selectedRooms.map((room) => room.questions)),
        _.flatten(addons.map((addon) => addon.questions))
      ])
    )
  );

  $('#mandatory').on('change', processPaymentValidate);

  // credit card process payment container
  if ($('#process-payment-container').length) {
    $('#submitWithoutPaymentButton').on(
      'click',
      null,
      null,
      handleProcessPaymentEpsFormSubmit
    );
  }

  const error = getUrlParameter('error') as string | undefined;
  if (error && personBooking) {
    modalalert(error.replace(/\+/g, ' '), 'error', false);
  }
}

$(function() {
  // review booking page
  if ($('#processpayment').length) {
    initProcessPayment();
  }
});
